import styled from 'styled-components';

export const PageContainer = styled.div`
    max-width: 1000px;
    margin-right: auto;
    margin-left: auto;
`;